import React from "react";

    const Info = () => {
        return (
          <div className="row justify-content-center pt-3 pb-3">
            <div className="col-lg-7">
              <div className="p-2">
                <p className="mb-0 text-secure text-center">
                  {" "}
                  <span className="ml-4 mb-2">
                    Your given information is private and secured.
                  </span>
                </p>
              </div>
            </div>
          </div>
        )
    }
    export default Info